import {NewsSvc} from '../services/NewsSvc';
import directives from './module';

class News {
    delayShowNews = 1e+1;
    stopRepeatNews: ng.IPromise<any>;
    newsList: Array<string> = [];
    currentNewsItem: any;


    constructor(private $scope: ng.IScope,
                private $sce: ng.ISCEService,
                private $interval: ng.IIntervalService,
                private $element: ng.IAugmentedJQuery,
                private NewsSvc: NewsSvc) {

        $scope.$watch(() => NewsSvc.newsList, (list: Array<string>) => {
            if (!list) return;
            this.newsList = list;
            this.setCurrentNews();
            const appliedClassName = 'applied';
            if (this.newsList.length) {
                setTimeout(() => this.$element[0].classList.add(appliedClassName), this.delayShowNews);
            } else {
                this.$element[0].classList.remove(appliedClassName);
            }
        });
        $scope.$on('$destroy', () => $interval.cancel(this.stopRepeatNews));
    }

    get currentNews() {
        return this.$sce.trustAsHtml(this.currentNewsItem.html);
    }

    setCurrentNews(index = this.NewsSvc.currentIndex) {
        this.currentNewsItem = this.newsList[index] || this.newsList[0];
        this.$interval.cancel(this.stopRepeatNews);
        this.stopRepeatNews = this.$interval(() => {
            this.NewsSvc.currentIndex = index = ++index >= this.newsList.length ? 0 : index;
            this.currentNewsItem = this.newsList[index];
        }, this.delayShowNews);
    }

    deleteNews() {
        this.NewsSvc.deleteNews(this.currentNewsItem.id);
    }

}

directives.component('news', {
    controller: News,
    controllerAs: 'NewsCtrl',
    templateUrl: require('news.html')
});


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/newsDirective.ts